module.exports = __webpack_public_path__ + "img/four-color-deck.6a23e75f.png";